export default __webpack_public_path__ + "static/media/Gallery7.0900e2d6.jpg";